module.exports = __webpack_public_path__ + "img/101.cd277aa1.jpg";